import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, title, sub, id }) => (
  <div id={id} className="max-w-3xl">
    {overline && <span className="overline">{overline}</span>}
    <h2 className="mt-3 font-head font-black uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.05]">
      {title}
    </h2>
    {sub && <p className="mt-4 text-white/60 text-base md:text-lg leading-relaxed">{sub}</p>}
  </div>
);
